import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.promise";

/*
 * Copyright (c) 2018 Wells Fargo. 45 Fremont Street, San Francisco, CA 94105 All rights reserved.
 *
 *This software is the confidential and proprietary information of Wells Fargo
 *bank. ('Confidential Information'). You shall not disclose such Confidential
 *Information and shall use it only in accordance with the terms of the license
 *agreement you entered into with WellsFargo.
 *
 *Author: Thomas Barry
 *
 *Description:
*/
import { showStopMessage } from '../../store/stop-message/actions';
import { getStore } from '../../store/store';
import { showConfirmation } from '../../store/navigation/actions';
import browserNavigation from '../navigation-types/browser-navigation';
import getString from '../../strings/get-string';
import logger from '../../logger/logger';
var navigationType = 'Foresee navigation';
var defaultOptions = {
  foreseeConfirmation: true
}; // Start the location navigation process. Showing the spinner on the overlay is optional
// Returns the settings

var _start = function _start(navigation) {
  var settings = Object.assign({}, defaultOptions, navigation);
  logger.debug("".concat(navigationType, ": Starting"));
  return Promise.resolve(settings);
};

var _confirmForeseeNavigation = function _confirmForeseeNavigation(navigation) {
  return new Promise(function (resolve, reject) {
    new Promise(function (confirmResolve, confirmReject) {
      getStore().dispatch(showConfirmation({
        confirmationType: 'foresee',
        confirmResolve: confirmResolve,
        confirmReject: confirmReject
      }));
    }).then(function () {
      return resolve(navigation);
    }, function () {
      navigation.confirmationDeclined = true;
      reject(navigation);
    });
  });
};

var _doNavigation = function _doNavigation(navigation) {
  navigation.navigationItem.url = window.fswf.foreseeFeedbackLink;
  navigation.navigationItem.forceWindow = true;
  return browserNavigation(navigation);
};

var _cleanup = function _cleanup(navigation) {
  logger.debug("".concat(navigationType, ": Cleanup"));
  return Promise.resolve(navigation);
};

export default (function (navigation) {
  return new Promise(function (resolve, reject) {
    return _start(navigation).then(_confirmForeseeNavigation).then(_doNavigation).then(_cleanup).then(function (navigation) {
      logger.debug("".concat(navigationType, ": Finished"));
      resolve(navigation);
    }, function (navigation) {
      if (!navigation.confirmationDeclined) {
        logger.warn("".concat(navigationType, " failed: ").concat(navigation.failureReason));
        logger.debug("".concat(navigationType, ": Show stop message"));
        getStore().dispatch(showStopMessage(getString('global.no.internet.connection')));
      }

      reject(navigation);
    });
  });
});